<template>
  <mad-overlay v-model="value">
    <div class="has-gutter row center-xs middle-xs" style="height: 100%">
      <div class="col-xs-fluid-22 col-md-8">
        <mad-card>
          <div style="padding: 24px 16px;">
            <img v-if="image" :src="image" alt="" style="max-width: 50%; width: 50%; margin-bottom: 16px;" />
            <img v-if="!image && type === 'success'" src="../assets/done.svg" alt="" style="max-width: 50%; width: 50%; margin-bottom: 16px;" />
            <img v-if="!image && type === 'confirm'" src="../assets/confirmed.svg" alt="" style="max-width: 50%; width: 50%; margin-bottom: 16px;" />
            <img v-if="!image && type === 'cancel'" src="../assets/cancel.svg" alt="" style="max-width: 50%; width: 50%; margin-bottom: 16px;" />
            <div class="font-display1 font-center font-bold">{{ header }}</div>
            <div class="font-body font-center" style="margin-bottom: 16px;">{{ message }}</div>
            <div style="margin: 0 auto">
              <mad-button @click="stop" class="primary" button-style="raised" style="margin: 0 auto; display: block">{{ buttonText }}</mad-button>
            </div>
          </div>
        </mad-card>
      </div>
    </div>
  </mad-overlay>
</template>

<script>
import Overlay from "./Overlay.vue";
import Card from "./Card.vue";
import Button from "./Button.vue";
// import ripple from '../directives/v-ripple'
export default {
  components: {
    "mad-button": Button,
    "mad-overlay": Overlay,
    "mad-card": Card,
  },
  //   directives: {
  //     ripple
  //   },
  data() {
    return {
      value: false,
    };
  },
  methods: {
    stop() {
      this.buttonCallBack();
      this.value = false;
    },
  },
  mounted() {
    window.setTimeout(() => {
      // Helper.addClass(this.$el, 'show')
      this.value = true;
      // this.removeFunction = () => {
      //     Helper.removeClass(this.$el, 'show')
      //     var whichTransitionEvent = function () {
      //         var el = document.createElement('fakeelement');
      //         var transitions = {
      //             'transition': 'transitionend',
      //             'OTransition': 'oTransitionEnd',
      //             'MozTransition': 'transitionend',
      //             'WebkitTransition': 'webkitTransitionEnd'
      //         }

      //         for (var t in transitions) {
      //             if (el.style[t] !== undefined) {
      //                 return transitions[t];
      //             }
      //         }
      //     }
      //     let transition = whichTransitionEvent()
      //     Helper.one(this.$el, transition, () => {
      //         this.finished()
      //     })
      // }
      // this.timeout = window.setTimeout(() => {
      //     this.removeFunction()
      // }, 5000);
    }, 100);
  },
};
</script>
